import { TabNames } from "~buildable/utils/enums";
import {capitalize, getHslFromHex} from "~buildable/utils/helpers";

export const INSPECTOR_TABS = TabNames ? [
  {
    name: TabNames.DETAILS,
    title: "Details",
    className: "edit-post-sidebar__panel-tab details"
  },
  {
    name: TabNames.STYLE,
    title: "Style",
    className: "edit-post-sidebar__panel-tab style"
  },
  {
    name: TabNames.ADDITIONAL,
    title: "Additional",
    className: "edit-post-sidebar__panel-tab additional"
  }
] : [];

let options = [];
let allOptions = [];
let map = {};
let allMap = {};
let textColorMap = {};
let allTextColorMap = {};
if (themeVariables) {
  Object.keys(themeVariables).forEach(key => {
    const name = key.replace("-color", "");

    const hsl = getHslFromHex(themeVariables[key]);
    const textColor = hsl.l > 50 ? "black" : "white";

    if (key.indexOf("gray") === -1 && key !== "black") {
      allOptions.push({
        value: name,
        label: capitalize(name),
        color: themeVariables[key]
      });

      allMap[name] = themeVariables[key];
      allTextColorMap[name] = textColor;
    }

    if (
      key.indexOf("quinary") === -1 &&
      key.indexOf("gray") === -1 &&
      key !== "black"
    ) {
      options.push({
        value: name,
        label: capitalize(name),
        color: themeVariables[key]
      });

      map[name] = themeVariables[key];
      textColorMap[name] = textColor;
    }
  });
}
export const THEME_VARIABLES = options;
export const THEME_VARIABLES_ALL = allOptions;
export const THEME_VARIABLES_MAP = map;
export const THEME_VARIABLES_MAP_ALL = allMap;
export const THEME_VARIABLES_TEXT_MAP = textColorMap;
export const THEME_VARIABLES_TEXT_MAP_ALL = allTextColorMap;

export const CARDS_DISPLAY_OPTIONS = [
  {
    label: "Slider",
    value: "slider"
  },
  {
    label: "Row",
    value: "row"
  }
];

export const STANDARD_RICHTEXT_FORMATS = [
  "core/bold",
  "core/italic",
  "core/link",
  "core/strikethrough",
  "core/underline",
  "buildable/theme-text-color-format"
];

export const STYLE_RICHTEXT_FORMATS = [
  "core/bold",
  "core/italic",
  "core/strikethrough",
  "core/underline",
  "buildable/theme-text-color-format"
];

export const SPONSOR_CLICK_OPTIONS = [
  {
    label: "Do Nothing",
    value: "nothing"
  },
  {
    label: "Open Sponsor Modal",
    value: "modal"
  },
  {
    label: "Link to Sponsor's URL",
    value: "link"
  }
];
